import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSubCategories } from "../../Redux/Slices/Categories/subCategoriesAction";
import { postProduct } from "../../Redux/Slices/Products/productsAction";
import NavBar from "../NavBar/NavBar";

export const FormProducts = () => {
  const dispatch = useDispatch();
  const [input, setInput] = useState({
    name: "",
    image: "",
    disponible: "Disponible",
    subCategory: "",
    description: "",
    price: "",
  });
  const { subCategories } = useSelector((state) => state.subCategories);

  useEffect(() => {
    dispatch(getSubCategories());
  }, []);

  function handleSelectSubCategories(e) {
    setInput({
      ...input,
      subCategory: e.target.value,
    });
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    dispatch(postProduct(input));
    setInput({
      name: "",
      image: "",
      disponible: "",
      subCategory: "",
      description: "",
      price: "",
    });
    window.alert("Producto creado exitosamente");
    window.location.replace("/");
  };

  function handleSelect(e) {
    setInput({ ...input, disponible: e.target.value });
  }
  const handleChange = (event) => {
    setInput({ ...input, [event.target.name]: event.target.value });
  };

    return (
        <div>
            <NavBar />
            <div                
                class=" min-h-screen bg-gray-100 py-6 flex flex-col justify-center sm:py-12"
            >
                <div class="mt-10 p-6 relative py-3 sm:max-w-xl sm:mx-auto">
                    <div class="absolute inset-0 bg-gradient-to-r from-red-800 to-red-500 shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl"></div>
                    <div class="relative px-4 py-10 bg-gray-300 shadow-lg sm:rounded-3xl sm:p-20">
                        <div class="max-w-md mx-auto">
                            <div>
                                <h1 class="text-2xl font-semibold text-red-900">
                                    Crear Nuevo Producto
                                </h1>
                            </div>
                            <div class="divide-y divide-gray-200">
                                <div class="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                                    <div class="relative">
                                        <input
                                            id="Name"
                                            name="name"
                                            value={input.name}
                                            placeholder="Nombre"
                                            onChange={handleChange}
                                            class="peer placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none rounded-lg border-2 focus:borer-rose-600"
                                           
                                        />
                                        <label
                                            for="nombre"
                                            class="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm ml-5"
                                        >
                                            Nombre
                                        </label>
                                    </div>
                                    <div class="relative">
                                        <input
                                            id="description"
                                            name="description"
                                            value={input.description}
                                            placeholder="Descripción"
                                            onChange={handleChange}
                                            maxlength="70"
                                            class="peer placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none rounded-lg border-2 focus:borer-rose-600"
                                        />
                                        <label
                                            for="description"
                                            class="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm ml-5"
                                        >                                            Descripción
                                        </label>
                                    </div>

                                    <div class="grid grid-cols-1 mt-5 mx-7">
                                        <label class="uppercase md:text-sm text-xs text-red-500 text-light font-semibold">
                                            Disponibilidad
                                        </label>
                                        <select
                                            class="py-2 px-3 rounded-lg border-2 border-red-300 mt-1 focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent"
                                            onChange={handleSelect}
                                            value={input.disponible}
                                        >
                                            <option>Disponible</option>
                                            <option>No Disponible</option>
                                        </select>
                                    </div>
                                    <div class="relative">
                                        <div class="grid grid-cols-1 mt-5 mx-7">
                                            <input
                                                id="Price"
                                                name="price"
                                                value={input.price}
                                                onChange={handleChange}
                                                placeholder="Precio"
                                                class="peer placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none rounded-lg border-2 focus:borer-rose-600"
                                            />
                                            <label
                                                for="nombre"
                                                class="absolute left-5 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm ml-5"
                                            >
                                                Precio
                                            </label>
                                        </div>
                                    </div>
                                    <div class="grid grid-cols-1 mt-5 mx-7">
                                        <label class="uppercase md:text-sm text-xs text-red-500 text-light font-semibold">
                                            Sub Categoria
                                        </label>
                                        <select
            className="py-2 px-3 rounded-lg border-2 border-red-300 mt-1 focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent"
            value={input.subCategory}
            onChange={handleSelectSubCategories}
          >
            <option disabled value="">
              Seleccionar subcategoria
            </option>
            {subCategories?.map((e) => (
              <option value={e._id} key={e.id}>
                {e.name}
              </option>
            ))}
          </select>
                                    </div>
                                    <div class="grid grid-cols-1 mt-5 mx-7">
                                        <label
                                            for="Image"
                                            class="uppercase md:text-sm text-xs text-red-500 text-light font-semibold"
                                        >
                                            Imagen
                                        </label>
                                        <input
                                        class="peer placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none rounded-lg border-2 focus:borer-rose-600"
                                            id="input"
                                            type="text"
                                            value={input.image}
                                            name="image"
                                            onChange={handleChange}
                                        />
                                        <img
                                            src={input.image}
                                            style={{
                                                width: "100px",
                                                height: "100px",
                                            }}
                                        />
                                    </div>
                                    <div class="relative">
                                        <button
                                            onClick={handleSubmit}
                                            class="bg-gray-500 text-white rounded-md px-2 py-1"
                                            type="submit"
                                        >
                                            Crear Producto
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormProducts;
